/* eslint-disable no-unused-vars */
import a from "axios";
import Vue from "vue";
import router from "@/router";
import { i18n } from "../main";

const baseURL = process.env.VUE_APP_BASE_URL;

const axios = a.create({
  baseURL,
});

Vue.prototype.$axios = new Vue({
  data() {
    return {
      modal: {
        show: false,
        titulo: "",
        conteudo: "",
      },
    };
  },
  methods: {
    modalBar(titulo, conteudo) {
      this.modal.show = true;
      this.modal.titulo = titulo;
      this.modal.conteudo = conteudo;
    },
    getHeaders() {
      let headers = { "Content-Type": "application/json" };

      if (this.getCookie("oe_jwt")) {
        headers = {
          Authorization: "Bearer " + this.getCookie("oe_jwt"),
          "Content-Type": "application/json",
        };
      }

      return headers;
    },
    async get(url = "", param = false) {
      try {
        const response = await axios({
          method: "get",
          url: url,
          param: param,
          responseType: "json",
          responseEncoding: "utf8",
          headers: this.getHeaders(),
        });
        return response.data;
      } catch (err) {
        if (
          err.response.data == "Expired token" ||
          err.response.data == "Authentication of server type required"
        ) {
          this.$config.alert(
            "Sua sessão expirou! Faça login novamente.",
            this.$config.dados.errorColor
          );
          this.rota("/");
          this.destroy(true);
          return;
        }
        this.$config.alert(
          err.response.data.message,
          this.$config.dados.errorColor
        );
      }
    },
    async post(url = "", dados = [], cache = false) {
      try {
        const response = await axios({
          method: "post",
          url: url,
          data: dados,
          responseEncoding: "utf8",
          headers: this.getHeaders(),
        });
        if (response.data.sucesso) {
          if (response.data.msg) {
            this.$config.alert(
              response.data.msg,
              this.$config.dados.successColor
            );
          } else {
            this.$config.alert(
              i18n.t('common.success_request'),
              this.$config.dados.successColor
            );
          }
        }
        return response.data;
      } catch (err) {
        if (
          err.response.data.message == "Expired token" ||
          err.response.data == "Authentication of server type required"
        ) {
          this.$config.alert(
            i18n.t('common.session_expired'),
            this.$config.dados.errorColor
          );
          this.rota("/");
          this.destroy(true);
          return;
        }
        /**
         * @description: Tratando erros de validação de documentos no cadastro de loja,
         */
        if (
          err.response.data.message ==
          "Variable pdf_comprovante_endereco are required!"
        ) {
          this.$config.alert(
            i18n.t('common.required_documents'),
            this.$config.dados.errorColor
          );
          return;
        }

        if (
          err.response.data.message == "Variable pdf_documento are required!"
        ) {
          this.$config.alert(
            i18n.t('common.required_documents'),
            this.$config.dados.errorColor
          );
          return;
        }
        if (
          err.response.data.message ==
          "Variable pdf_contrato_social are required!"
        ) {
          this.$config.alert(
            i18n.t('common.required_documents'),
            this.$config.dados.errorColor
          );
          return;
        }
        this.$config.alert(
          err.response.data.message,
          this.$config.dados.errorColor
        );
      }
    },
    async put(url = "", dados = [], cache = false) {
      try {
        const response = await axios({
          method: "put",
          url: url,
          data: dados,
          responseEncoding: "utf8",
          headers: this.getHeaders(),
        });
        if (response.data.msg) {
          this.$config.alert(
            response.data.msg,
            this.$config.dados.successColor
          );
          return response.data;
        }
        this.$config.alert(
          "Operação realizada com sucesso",
          this.$config.dados.successColor
        );
        return response.data;
      } catch (err) {
        if (
          err.response.data.message == "Expired token" ||
          err.response.data == "Authentication of server type required"
        ) {
          this.$config.alert(
            "Sua sessão expirou! Faça login novamente.",
            this.$config.dados.errorColor
          );
          this.rota("/");
          this.destroy(true);
          return;
        }
        /**
         * @description: Tratando erros de validação de documentos no cadastro de loja,
         */
        if (
          err.response.data.message ==
          "Variable pdf_comprovante_endereco are required!"
        ) {
          this.$config.alert(
            "Faça upload dos documentos necessários! (Documentos)",
            this.$config.dados.errorColor
          );
          return;
        }
        if (
          err.response.data.message == "Variable pdf_documento are required!"
        ) {
          this.$config.alert(
            "Faça upload dos documentos necessários! (Documentos)",
            this.$config.dados.errorColor
          );
          return;
        }
        if (
          err.response.data.message ==
          "Variable pdf_contrato_social are required!"
        ) {
          this.$config.alert(
            "Faça upload dos documentos necessários! (Documentos)",
            this.$config.dados.errorColor
          );
          return;
        }
        if (
          err.response.data.message == "Variable pdf_procuracao are required!"
        ) {
          this.$config.alert(
            "Faça upload dos documentos necessários! (Documentos)",
            this.$config.dados.errorColor
          );
          return;
        }
        this.$config.alert(
          err.response.data.message,
          this.$config.dados.errorColor
        );
      }
    },
    async delete(url = "", param = false) {
      try {
        const response = await axios({
          method: "delete",
          url: url,
          param: param,
          responseEncoding: "utf8",
          headers: this.getHeaders(),
        });

        if (response.data.sucesso) {
          return this.$config.alert(
            response.data.msg,
            this.$config.dados.successColor
          );
        } else if (response.data.error) {
          return this.$config.alert(
            response.data.msg,
            this.$config.dados.errorColor
          );
        } else if (!response.data.sucesso) {
          return this.$config.alert(
            response.data.msg,
            this.$config.dados.errorColor
          );
        } else {
          return response.data;
        }
      } catch (err) {
        if (err.response.data.message) {
          this.$config.alert(
            err.response.data.message,
            this.$config.dados.errorColor
          );
        } else {
          this.$config.alert(err.response.data, this.$config.dados.errorColor);
        }
      }
    },
    async postData(url = "", dados = [], cache = false) {
      url = this.setParams(url);
      let form_data = new FormData();
      for (var key in dados) {
        form_data.append(key, dados[key]);
      }
      try {
        const response = await axios({
          method: "post",
          url: this.setParams(url),
          data: form_data,
          responseEncoding: "utf8",
          headers: this.getHeaders(),
        });
        if (response != undefined) {
          if (response.data.error) {
            if (response.data.error.code == 1) {
              this.rota("/");
              this.destroy(true);
            }
            if (
              response.data.error.code == 13225 ||
              response.data.error.code == 13227
            ) {
              this.rota("/");
            }
            if (
              response.data.error.code == 13124 ||
              response.data.error.code == 13087 ||
              response.data.error.code == 13020 ||
              response.data.error.code == 13005
            ) {
              // this.rota('Perfil')
              return false;
            }
            this.modalBar("", response.data.error.message);
            return false;
          }
          return response.data.result;
        } else {
          if (response.error && response.error.code == 1) {
            this.rota("/");
            this.destroy(true);
          }
          if (response.error && response.error.code == 71033) {
            this.modalBar("", response.error.message);
            return;
          }
          this.modalBar("", response);
          return false;
        }
      } catch (err) {
        this.modalBar("", err);
      }
    },
    async postPDF(url = "", dados = [], cache = false) {
      try {
        const response = await axios({
          method: "post",
          url: url,
          data: dados,
          responseEncoding: "utf8",
          headers: this.getHeaders(),
          responseType: "arraybuffer",
        });
        if (response.data.sucesso) {
          this.$config.alert(
            response.data.msg,
            this.$config.dados.successColor
          );
        }
        return response.data;
      } catch (err) {
        if (
          err.response.data.message == "Expired token" ||
          err.response.data == "Authentication of server type required"
        ) {
          this.$config.alert(
            "Sua sessão expirou! Faça login novamente.",
            this.$config.dados.errorColor
          );
          this.rota("/");
          this.destroy(true);
          return;
        }
        this.$config.alert(
          err.response.data.message,
          this.$config.dados.errorColor
        );
      }
    },
    setLocal(nome, dados) {
      var today = new Date();
      today.setSeconds(today.getSeconds() + 15);
      return window.localStorage.setItem(
        nome,
        JSON.stringify({
          session: today.getTime(),
          data: dados,
        })
      );
    },
    setCookie(nome, dados, stringify = false) {
      var date = new Date();
      date.setHours(date.getHours() + 12);
      var expires = date;
      return (document.cookie = `${nome}=${
        stringify ? JSON.stringify(dados) : dados
      };expires=${expires}path=/;SameSite=Strict;Secure;`);
    },
    getCookie(cookieName, parse = false) {
      let allCookies = document.cookie.split(";");
      for (let i = 0; i < allCookies.length; i++) {
        let cookie = allCookies[i].split("=");
        if (cookie[0].trim() === cookieName) {
          return parse ? JSON.parse(cookie[1]) : cookie[1];
        }
      }
    },
    removeCookie(nome) {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var cookieName = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        if (cookieName.trim() === nome) {
          var date = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie = `${cookieName.trim()}=;${date};path=/;`;
        }
      }
    },
    getLocal(nome) {
      if (nome in localStorage) {
        return JSON.parse(window.localStorage.getItem(nome));
      }
      return false;
    },
    destroy(session) {
      this.remove("confirm_login");
      if (session) {
        this.remove("history");
        this.remove("oe_user_info");
        this.rota("/");
      }
    },
    remove(nome) {
      if (nome in localStorage) {
        window.localStorage.removeItem(nome);
      }
      return false;
    },
    rota(path) {
      if (path.length == 0) {
        console.error("Não existe link por favor verificar!");
        return;
      }
      if (path.indexOf("http") != -1) {
        window.open(path, "_blank");
        return;
      }
      router.push(path).catch(() => {});
    },
    logout() {
      window.localStorage.clear();
      this.removeCookie("oe_jwt");
      this.destroy(true);
      this.rota("/");
    },
  },
});
